module.exports = __webpack_public_path__ + "static/media/Mini-PLLD.d899fe12.jpg";